import { getEntityLabel } from './entityRegistry';

type ConversationDisplayFields = {
  displayTitle?: string | null;
  displaySubtitle?: string | null;
  subject?: string | null;
  entityType?: string | null;
  entityId?: string | null;
  clientContact?: string | null;
  audience?: 'INTERNAL' | 'CLIENT';
};

export function conversationTitle(row: ConversationDisplayFields): string {
  if (row.displayTitle?.trim()) return row.displayTitle.trim();
  if (row.subject?.trim()) return row.subject.trim();
  if (row.entityType && row.entityId) return getEntityLabel(row.entityType, row.entityId);
  return row.clientContact?.trim() || 'Conversation';
}

export function conversationSubtitle(row: ConversationDisplayFields): string | null {
  if (row.displaySubtitle?.trim()) return row.displaySubtitle.trim();
  if (!row.audience) return null;
  return row.audience === 'INTERNAL' ? 'Interne' : 'Client';
}

type ConversationInboxFields = ConversationDisplayFields & {
  lastMessagePreview?: string | null;
  lastMessageFromViewer?: boolean;
  lastMessageAt?: string | null;
};

/** Compact relative label for inbox preview suffix (e.g. `3 min`, `2 h`). */
export function conversationInboxTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 45_000) return 'maintenant';
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} j`;
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
}

export function conversationInboxPreview(row: ConversationInboxFields): string {
  const preview = row.lastMessagePreview?.trim() || 'Aucun message.';
  if (row.lastMessageFromViewer) return `Vous : ${preview}`;
  return preview;
}
